import MainAnalyticPage from "pageComponents/analysis/MainAnalyticPage";
import React from "react";

export default function AnalysisPage() {
  return (
    <div className="mt-[10vh]">
      <MainAnalyticPage />
    </div>
  );
}
